import { useState } from 'react';

import { ActionButton } from 'commonComponents/ActionButton';

import { LicenseDetails } from 'api/licenses';
import { MoveIcon } from 'icons';
import { ROLE_DEFINITIONS } from 'roles/definitions';
import { RoleDependentComponent } from 'roles/RoleDependentComponent';

import { MoveLicenseFileDialog } from '../MoveLicenseFileDialog';

type LicenseFileMoveButtonProps = {
    license: LicenseDetails;
    licenseFileIds: number[];
    disabled?: boolean;
    onSubmitCallback?: () => void;
    title?: string;
    tooltip?: string;
};

export function LicenseFileMoveButton({
    license,
    licenseFileIds,
    disabled = false,
    onSubmitCallback,
    title = 'Move to license',
    tooltip,
}: LicenseFileMoveButtonProps) {
    const [open, setOpen] = useState(false);

    if (license.invalidated || !license.configuration.product.allow_move_license) return null;

    return (
        <>
            <RoleDependentComponent
                userRole={ROLE_DEFINITIONS.LicenseManager}
                component={ActionButton}
                iconClass={MoveIcon}
                variant="contained"
                color="primary"
                onClick={() => setOpen(true)}
                title={title}
                data-testid="LicenseFileDetails_Move"
                disabled={disabled}
                tooltip={tooltip}
            />
            {open && (
                <MoveLicenseFileDialog
                    license={license}
                    licenseFileIds={licenseFileIds}
                    setOpen={setOpen}
                    onSubmitCallback={onSubmitCallback}
                />
            )}
        </>
    );
}
